import React, { useEffect, useState } from 'react'
import { PROFILE_SECTIONS, profileSectionAnchorId } from './profileDetailSections'

function scrollToSection(sectionId) {
  const el = document.getElementById(profileSectionAnchorId(sectionId))
  if (!el) return
  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export default function ProfileSectionNav({ observeKey }) {
  const [activeSection, setActiveSection] = useState(PROFILE_SECTIONS[0]?.id || 'overview')

  useEffect(() => {
    const elements = PROFILE_SECTIONS
      .map((section) => document.getElementById(profileSectionAnchorId(section.id)))
      .filter(Boolean)

    if (!elements.length) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)
        if (!visible.length) return
        const id = visible[0].target.id.replace('profile-section-', '')
        setActiveSection(id)
      },
      { rootMargin: '-96px 0px -55% 0px', threshold: [0, 0.15, 0.4, 0.75] }
    )

    for (const el of elements) observer.observe(el)
    return () => observer.disconnect()
  }, [observeKey])

  return (
    <nav
      className="sticky top-0 py-4 pl-4 pr-3 bg-slate-100 border-r border-slate-200 self-start max-lg:static max-lg:border-r-0 max-lg:border-b max-lg:flex max-lg:flex-wrap max-lg:gap-1 max-lg:px-3 max-lg:py-3"
      aria-label="Profile sections"
    >
      <h2 className="text-[11px] uppercase tracking-wider text-slate-500 font-bold m-0 mb-2 px-2 max-lg:hidden">
        On this page
      </h2>
      {PROFILE_SECTIONS.map((section) => {
        const active = activeSection === section.id
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => scrollToSection(section.id)}
            className={`block w-full text-left px-3 py-2 mb-0.5 rounded-lg text-[13px] font-medium transition-colors max-lg:w-auto ${
              active
                ? 'bg-white text-teal-800 font-bold shadow-sm'
                : 'bg-transparent text-slate-500 hover:bg-slate-200 hover:text-slate-900'
            }`}
          >
            {section.label}
          </button>
        )
      })}
    </nav>
  )
}

export { scrollToSection }
